import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Botão "Voltar" que retorna pra PÁGINA ANTERIOR (histórico), não pra uma rota
 * fixa — assim o usuário sempre volta de onde veio (ex: de Primeiros Passos →
 * Escala → "Voltar" cai de volta em Primeiros Passos, não numa tela fixa).
 *
 * Se a pessoa entrou por link direto (sem histórico dentro do app), cai no
 * `fallback`. O React Router mantém `history.state.idx`: idx > 0 garante que há
 * uma entrada anterior nesta sessão pra onde voltar com segurança.
 */
export function useSmartBack(fallback = "/painel") {
  const navigate = useNavigate();
  return useCallback(() => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === "number" && idx > 0) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
